// extracted by mini-css-extract-plugin
module.exports = {"star":"styles_star__2hRbX","icon":"styles_icon__3zS2l","primary":"styles_primary__wJr47","secondary":"styles_secondary__3AGZ9"};